 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","pages-login-login-module":"pages-login-login-module","pages-register-register-module":"pages-register-register-module","core-js-js":"core-js-js","css-shim-206ea950-3169f23e-js":"css-shim-206ea950-3169f23e-js","default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~049cbff9":"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~049cbff9","default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~3a05caec":"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~3a05caec","default~pages-beds-beds-module~pages-chairs-chairs-module~pages-diner-diner-module~pages-tables-tabl~298c5d71":"default~pages-beds-beds-module~pages-chairs-chairs-module~pages-diner-diner-module~pages-tables-tabl~298c5d71","pages-beds-beds-module":"pages-beds-beds-module","pages-chairs-chairs-module":"pages-chairs-chairs-module","pages-diner-diner-module":"pages-diner-diner-module","pages-tables-tables-module":"pages-tables-tables-module","docs-folders-docs-folders-module":"docs-folders-docs-folders-module","home-home-module":"home-home-module","pages-calendar-details-calendar-details-module":"pages-calendar-details-calendar-details-module","pages-chats-chats-module":"pages-chats-chats-module","pages-diner-edit-diner-edit-module":"pages-diner-edit-diner-edit-module","pages-docs-files-docs-files-module":"pages-docs-files-docs-files-module","pages-interior-chat-interior-chat-module":"pages-interior-chat-interior-chat-module","pages-notifications-notifications-module":"pages-notifications-notifications-module","pages-tasks-done-tasks-done-module":"pages-tasks-done-tasks-done-module","pages-tasks-tasks-module":"pages-tasks-tasks-module","pages-upload-document-upload-document-module":"pages-upload-document-upload-document-module","profile-profile-module":"profile-profile-module","default~pages-calendar-calendar-module~pages-calendar-food-calendar-food-module~pages-trazabilidad-t~e6e86538":"default~pages-calendar-calendar-module~pages-calendar-food-calendar-food-module~pages-trazabilidad-t~e6e86538","pages-trazabilidad-trazabilidad-module":"pages-trazabilidad-trazabilidad-module","pages-calendar-calendar-module":"pages-calendar-calendar-module","pages-calendar-food-calendar-food-module":"pages-calendar-food-calendar-food-module","dom-96781eef-a2fb04dd-js":"dom-96781eef-a2fb04dd-js","dom-js":"dom-js","index-69c37885-js":"index-69c37885-js","pages-add-plato-to-daily-menu-add-plato-to-daily-menu-module":"pages-add-plato-to-daily-menu-add-plato-to-daily-menu-module","pages-added-stock-products-added-stock-products-module":"pages-added-stock-products-added-stock-products-module","pages-allergens-allergens-module":"pages-allergens-allergens-module","pages-bed-details-bed-details-module":"pages-bed-details-bed-details-module","pages-chair-details-chair-details-module":"pages-chair-details-chair-details-module","pages-configuracion-plato-residencias-configuracion-plato-residencias-module":"pages-configuracion-plato-residencias-configuracion-plato-residencias-module","pages-cover-page-cover-page-module":"pages-cover-page-cover-page-module","pages-daily-menu-diners-daily-menu-diners-module":"pages-daily-menu-diners-daily-menu-diners-module","pages-details-details-module":"pages-details-details-module","pages-detalles-plato-detalles-plato-module":"pages-detalles-plato-detalles-plato-module","pages-diner-add-diner-add-module":"pages-diner-add-diner-add-module","pages-docs-download-docs-download-module":"pages-docs-download-docs-download-module","pages-docs-folder-details-docs-folder-details-module":"pages-docs-folder-details-docs-folder-details-module","pages-filter-filter-module":"pages-filter-filter-module","pages-folder-years-folder-years-module":"pages-folder-years-folder-years-module","pages-forgot-password-forgot-password-module":"pages-forgot-password-forgot-password-module","pages-idiomas-idiomas-module":"pages-idiomas-idiomas-module","pages-ingredientes-plato-ingredientes-plato-module":"pages-ingredientes-plato-ingredientes-plato-module","pages-meal-details-meal-details-module":"pages-meal-details-meal-details-module","pages-stock-edit-stock-edit-module":"pages-stock-edit-stock-edit-module","pages-stock-stock-module":"pages-stock-stock-module","pages-tabs-tabs-module":"pages-tabs-tabs-module","profile-edit-profile-edit-module":"profile-edit-profile-edit-module","shadow-css-4889ae62-23996f3f-js":"shadow-css-4889ae62-23996f3f-js","swiper-bundle-8bab85e6-js":"swiper-bundle-8bab85e6-js","ios-transition-504cdd09-js":"ios-transition-504cdd09-js","md-transition-fea2bbfb-js":"md-transition-fea2bbfb-js","swipe-back-35ad8e37-js":"swipe-back-35ad8e37-js","focus-visible-70713a0c-js":"focus-visible-70713a0c-js","hardware-back-button-5afe3cb0-js":"hardware-back-button-5afe3cb0-js","input-shims-a4fc53ac-js":"input-shims-a4fc53ac-js","status-tap-32c72c43-js":"status-tap-32c72c43-js","tap-click-ca00ce7f-js":"tap-click-ca00ce7f-js","canvg":"canvg","dompurify":"dompurify","html2canvas":"html2canvas"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
